import React from 'react'
import RegisterSteps from '../registerSteps/registerSteps'
import { getStepsRegisterSupplier } from '../registerSteps/utilsSteps';
import { TypeRegisterStep } from '../registerSteps/types';
import SrcImageLine from '@/main/assets/images/homepage/line_image_edited_1.png';
import * as S from '../styles';

function RegisterPublicSupplierScreen() {
  const steps: TypeRegisterStep[] = getStepsRegisterSupplier();

  return (
    <S.Container>
      <RegisterSteps
        typeRegister='supplier'
        orderStepsToRender={steps}
      />
      <S.ImageLine src={SrcImageLine} />
    </S.Container>
  )
}

export default RegisterPublicSupplierScreen